import { Container } from 'component-library';
import { useTranslation } from 'react-i18next';

import { WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page/SignedInPage.layout';

export const DisclosurePage = () => {
  const { t } = useTranslation();
  const pathSet = usePathSet();

  const defaultConfiguration = {
    name: 'disclosure_page',
    type: WidgetType.a_stack,
    widgets: [
      {
        name: 'disclosure_tabs',
        type: WidgetType.m_tabs,
        visible: true,
        relatedData: {
          styles: {
            root: 'justify-center items-center',
            tabsList: 'grid grid-cols-2 w-full justify-center items-center',
            tabTrigger: 'justify-center items-center w-full',
            content: 'w-full',
            tabLabel: 'typography-h3 font-normal',
            tabDescription: 'typography-body1',
          },
          tabs: [
            {
              default: true,
              label: t('shared.disclosure.tabs.dependencies.label'),
              description: t('shared.disclosure.tabs.dependencies.description'),
              path: pathSet.disclosureDependencies,
              routeSlug: 'dependencies',
              content: (
                <WidgetSlotRenderer
                  nestedWidget={{
                    name: 'dependencies_content',
                    type: WidgetType.o_c_industrial_activity_dependencies,
                    visible: true,
                    relatedData: {},
                  }}
                />
              ),
            },
            {
              default: false,
              label: t('shared.disclosure.tabs.impacts.label'),
              description: t('shared.disclosure.tabs.impacts.description'),
              path: pathSet.disclosureImpacts,
              routeSlug: 'impacts',
              content: (
                <WidgetSlotRenderer
                  nestedWidget={{
                    name: 'impacts_content',
                    type: WidgetType.o_c_industrial_activity_impacts,
                    visible: true,
                    relatedData: {},
                  }}
                />
              ),
            },
          ],
        },
      },
    ],
  };

  return (
    <SignedInPageLayout
      items={[]}
      withCustomContentContainer
      navBarProps={{
        title: t('navbar.disclosure'),
        showSearchBar: false,
      }}
    >
      <Container data-testid='disclosure-page'>
        <WidgetSlotRenderer nestedWidget={defaultConfiguration} />
      </Container>
    </SignedInPageLayout>
  );
};
